import React, { useState } from 'react';
import { Calculator } from 'lucide-react';

const QuoteCalculator = () => {
  const [selectedTier, setSelectedTier] = useState('');

  const tiers = [
    {
      id: 'premium',
      name: 'Premium Integrated',
      brands: 'Sub-Zero, Wolf, Gaggenau',
      priceRange: '$650 - $950',
      description: 'High-end integrated appliances requiring precision installation'
    },
    {
      id: 'midrange',
      name: 'Mid-Range Integrated',
      brands: 'Miele, Thermador, Bosch, Liebherr',
      priceRange: '$400 - $650',
      description: 'Quality integrated appliances with professional installation'
    },
    {
      id: 'standard',
      name: 'Standard Installation',
      brands: 'All major brands',
      priceRange: '$150 - $250',
      description: 'Standard appliance installation services'
    }
  ];

  const selectedTierData = tiers.find(tier => tier.id === selectedTier);

  return (
    <div className="quote-calculator">
      <div className="calculator-header">
        <Calculator size={32} className="calculator-icon" />
        <h3 className="heading-2">Quick Price Estimate</h3>
        <p className="body-regular text-secondary space-top-sm">
          Select your appliance brand to see the estimated price range
        </p>
      </div>

      <div className="calculator-content space-top-lg">
        <label className="calculator-label">Select Your Appliance Brand:</label>
        <select 
          value={selectedTier} 
          onChange={(e) => setSelectedTier(e.target.value)}
          className="calculator-select"
        >
          <option value="">Choose a brand tier...</option>
          {tiers.map((tier) => (
            <option key={tier.id} value={tier.id}>
              {tier.brands}
            </option>
          ))}
        </select>

        {selectedTierData && (
          <div className="calculator-result space-top-lg">
            <div className="result-tier">
              <span className="result-label">Service Tier:</span>
              <span className="result-value">{selectedTierData.name}</span>
            </div>
            <div className="result-price">
              <span className="result-label">Estimated Price Range:</span>
              <span className="result-value-price">{selectedTierData.priceRange}</span>
            </div>
            <p className="result-description body-small space-top-md">
              {selectedTierData.description}
            </p>
            <div className="result-note space-top-md">
              <p className="body-small text-secondary">
                * Final pricing depends on specific appliance model, installation complexity, and site conditions. Contact us for a detailed quote.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteCalculator;